<template>
  <v-card raised>
    <v-card-actions>
      <v-container>
        <v-layout align-center>
          <v-flex xs10>
            <!-- <v-textarea
              hide-details
              solo
              name="message"
              v-model="message"
              single-line
              auto-grow
              :label="$t('Mensaje')"
              rows="2"
            ></v-textarea> -->
            <!-- <aru-wysiwyg-editor v-model="message"></aru-wysiwyg-editor> -->

            <!-- Message size error alert -->
            <v-alert :value="showMessageSizeError" type="error">
              El tamaño del mensaje supera los 10 MB revise el tamaño de las imagenes.
            </v-alert>

            <custom-editor this.content v-model="message" @input="updateMessage"></custom-editor>
          </v-flex>
          <v-flex xs1 mb-2 class="text-xs-center">
            <v-dialog max-width="500px" v-model="uploadDialog">
              <v-hover :open-delay="0" slot="activator">
                <v-btn
                  slot-scope="{ hover }"
                  flat
                  icon
                  :color="`${hover ? 'primary' : 'grey lighten-1'}`"
                >
                  <v-icon>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-hover>

              <og-message-file-upload
                v-if="thread.category"
                :userId="thread.user_id"
                @closeDialog="uploadDialog = false"
                :category-id="categoryId"
                :month="month"
                @postdocument="sendMessageUpload"
              ></og-message-file-upload>
            </v-dialog>

            <!-- <v-btn icon flat class="mb-2" color="primary" id="attach-file-button" @click="addFile">
                            <v-icon>attach_file</v-icon>
            </v-btn>-->
          </v-flex>
          <v-flex xs1 mb-2 class="text-xs-center">
            <v-btn
              icon
              :color="message ? 'primary' : 'light'"
              :disabled="!message"
              @click="sendMessage"
            >
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import ThreadAPI from '../../services/thread.js';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import OgMessageFileUpload from './OgMessageFileUpload.vue';
// import AruWysiwygEditor from '@/components/commons/form/inputs/AruWysiwygEditor.vue';
import CustomEditor from '@/components/commons/form/inputs/CustomEditor.vue';

const moment = require('moment');
require('moment/locale/es');
// import OgUploadDocument from '@/components/commons/OgUploadDocument.vue';
export default {
  components: {
    // OgUploadDocument,
    // AruWysiwygEditor,
    CustomEditor,
    OgMessageFileUpload,
  },
  props: ['thread'],
  data() {
    return {
      message: '',
      searchConfigReady: false,
      formConfigReady: false,
      formConfig: {},
      month: moment().format('YYYY-MM'),
      uploadDialog: false,
      editor: null,
      editorOptions: 0,
      showMessageSizeError: false,
    };
  },
  mounted() {
    console.log(this.thread);
    this.getConfig();
  },
  computed: {
    categoryId() {
      if (this.thread && this.thread.categories) {
        return this.thread.categories[0].id;
      } else {
        return null;
      }
    },
  },
  methods: {
    getConfig() {
      this.searchConfigReady = false;
      this.formConfigReady = false;
      apiCtrl.get('/config/document').then(res => {
        console.log(res);
        if (res.data.data.hasOwnProperty('messageForm')) {
          this.formConfig = res.data.data.messageForm;
        }
        if (res.data.data.hasOwnProperty('search')) {
          this.searchConfig = res.data.data.search;
        }
        this.searchConfigReady = true;
        this.formConfigReady = true;
      });
    },
    sendMessage: function() {
      let data = {
        thread: this.thread.id,
        message: this.message,
      };
      console.log(data);
      this.showMessageSizeError = false;
      ThreadAPI.postMessage(data)
        .then(response => {
          this.$emit('created', response.data.data);
          console.log(response);
          // this.activeThreads.unshift(response.data);
          this.resetNewMessage();
        })
        .catch(error => {
          this.showMessageSizeError = true;
        });
    },
    sendMessageUpload: function(data) {
      console.log({
        mensage_data_attached: data,
      });
      let mess = {
        thread: this.thread.id,
        attached: data.data.media[0] ? data.data.media[0].id : null,
        message: 'Fichero subido: ' + data.data.name,
      };
      console.log(mess);
      ThreadAPI.postMessage(mess).then(response => {
        this.$emit('created', response.data.data);
        console.log(response);
        // this.activeThreads.unshift(response.data);
        // this.resetNewMessage();
        this.uploadDialog = false;
      });
    },
    resetNewMessage() {
      this.message = '';
    },
    addFile() {
      console.log('ADD FILE');
    },
    updateMessage(value) {
      this.newThreadData.message = value;
    },
  },
};
</script>
